import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders  } from '@angular/common/http';

import 'rxjs/add/operator/toPromise';

import * as ent from '../entities/index'
import * as filters from '../filters/index'
import * as serv from '../services/index'

import { Observable } from 'rxjs';

@Injectable()
export class MassUpdatesService {

    private baseRequestUrl = "/MassUpdates";  // URL to web api
    private processMassUpdatesFileUrl = '';
    private applyMassUpdatesUrl = '';

    appConfig: ent.AppConfig;

    constructor(private httpClient: HttpClient, private configService: serv.ConfigService) {
        this.baseRequestUrl = this.configService.appConfig.UrlBase + this.baseRequestUrl;

        this.processMassUpdatesFileUrl = this.baseRequestUrl + '/ProcessMassUpdatesFile';
        this.applyMassUpdatesUrl = this.baseRequestUrl + '/ApplyMassUpdates';
    }

    processMassUpdatesFile(request: ent.ProcessMassUpdateFileRequest): Observable<ent.Response> {
        return this.httpClient.post<ent.Response>(this.processMassUpdatesFileUrl, request);
    }

    applyMassUpdates(request: ent.ApplyMassUpdatesRequest): Observable<ent.Response> {
        return this.httpClient.post<ent.Response>(this.applyMassUpdatesUrl, request);
    }
    
}
